/** Default ordinary hours per leave day = 38h week / 5. */
export const HOURS_PER_LEAVE_DAY = 7.6;
